/**
 * Preferências do convite de avisos, guardadas por aparelho.
 *
 * Ficam no navegador porque é ao navegador que elas dizem respeito: o aviso é
 * por aparelho, não por conta, e a mesma pessoa pode querer receber no celular
 * e não no computador do trabalho.
 */
// Guarda ATE QUANDO o convite fica quieto, nao um sim/nao.
const SNOOZE_KEY = "push.inviteSnoozedUntil.v1";

// Tres horas: cobre quem se candidata a varias vagas de uma sentada sem tirar
// ninguem do canal. Recusar o convite nao e desligar o aviso -- quem desliga
// de proposito tem a marca de opt-out, que nao expira.
const SNOOZE_HOURS = 3;
const OPT_OUT_KEY = "push.optedOut.v1";

function readFlag(key) {
  try {
    return localStorage.getItem(key) === "1";
  } catch (e) {
    return false;
  }
}

function writeFlag(key, enabled) {
  try {
    if (enabled) localStorage.setItem(key, "1");
    else localStorage.removeItem(key);
  } catch (e) {
    // localStorage indisponível: vale só enquanto a aba estiver aberta.
  }
}

/** O convite foi recusado ha pouco e ainda esta no periodo de silencio. */
export function isPushInviteSnoozed() {
  try {
    const until = Number(localStorage.getItem(SNOOZE_KEY));
    // NaN em qualquer comparacao e falso, entao valor corrompido nao silencia.
    return until > Date.now();
  } catch (e) {
    return false;
  }
}

/** "Agora nao": some desta vez e volta depois do periodo. */
export function snoozePushInvite() {
  try {
    localStorage.setItem(
      SNOOZE_KEY,
      String(Date.now() + SNOOZE_HOURS * 60 * 60 * 1000)
    );
  } catch (e) {
    // localStorage indisponivel: vale so enquanto a aba estiver aberta.
  }
}

/**
 * A pessoa desligou os avisos de propósito, em Configurações.
 *
 * Sem esta marca o convite reaparece na candidatura seguinte, porque não haveria
 * como separar "nunca ativou" de "ativou e desligou" — e insistir com quem já
 * disse não é o caminho mais curto para ela bloquear o site no navegador, o que
 * não tem volta pela nossa mão.
 */
export function hasOptedOutOfPush() {
  return readFlag(OPT_OUT_KEY);
}

export function markOptedOutOfPush() {
  writeFlag(OPT_OUT_KEY, true);
}

/** Voltou a ligar: o convite pode ser oferecido de novo no futuro. */
export function clearPushOptOut() {
  writeFlag(OPT_OUT_KEY, false);
}
